import { render, staticRenderFns } from "./Reuse.vue?vue&type=template&id=5b85acb2&scoped=true"
import script from "./Reuse.vue?vue&type=script&lang=js"
export * from "./Reuse.vue?vue&type=script&lang=js"
import style0 from "./Reuse.vue?vue&type=style&index=0&id=5b85acb2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b85acb2",
  null
  
)

export default component.exports